import styled from 'styled-components';
import { HeadingStyle } from 'components/heading';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 64px 0 0;
  gap: 12px;
  align-items: center;
  height: 100vh;

  ${HeadingStyle} {
    margin-bottom: 24px;
  }
`;
